import moment from "moment";
import Select from "react-select";

import styles from "./Invoices.module.scss";

const selectStyles = {
  control: (base) => ({
    ...base,
    backgroundColor: "#6D7F92",
    border: "none",
    borderRadius: "30px",
    boxShadow: "none",
    padding: "0px 5px",
    minHeight: "unset",
    cursor: "pointer",
    minWidth: "88px",
    transition: "background-color 0.2s ease-in-out",
  }),
  // valueContainer: (base) => ({
  //   ...base,
  //   padding: "0px",
  //   height: "14px",
  // }),
  singleValue: (base) => ({
    ...base,
    color: "#FFFFFF",
    fontSize: "12px",
    lineHeight: "normal",
    fontWeight: "500",
    letterSpacing: "0.24px",
    margin: "0px",
  }),
  placeholder: (base) => ({
    ...base,
    color: "#6D7F92",
    fontSize: "12px",
    fontWeight: "500",
    lineHeight: "normal",
    letterSpacing: "0.24px",
  }),
  indicatorSeparator: () => ({
    display: "none",
  }),
  menu: (provided) => ({
    ...provided,
    borderRadius: "8px",
    border: "1px solid #E5E7EB",
    boxShadow:
      "0 4px 6px -1px rgba(0, 0, 0, 0.1), 0 2px 4px -1px rgba(0, 0, 0, 0.06)",
    zIndex: 1000,
  }),
  menuList: (provided) => ({
    ...provided,
    padding: "4px",
  }),
  option: (provided, state) => ({
    ...provided,
    color: "#29394D",
    fontSize: "12px",
    fontWeight: "500",
    backgroundColor: state.isFocused ? "#F3F4F6" : "white",
    padding: "8px 10px",
    borderRadius: "4px",
    margin: "2px 0",
    lineHeight: "normal",
    cursor: "pointer",
    "&:hover": {
      backgroundColor: "#F3F4F6",
    },
    ...(state.isSelected && {
      backgroundColor: "#C7E8FE",
      "&:hover": {
        backgroundColor: "#C7E8FE",
      },
    }),
  }),
  dropdownIndicator: (base, state) => ({
    ...base,
    color: "white",
    padding: 0,
    transform: state.selectProps.menuIsOpen && "rotate(180deg)",
    transition: "transform .3s ease-in-out",
    ":hover": {
      color: "white",
    },
  }),
  clearIndicator: (base) => ({
    ...base,
    color: "white",
    padding: 0,
    position: "absolute",
    right: "10px",
    svg: {
      width: 16,
      height: 16,
    },
    ":hover": {
      color: "white",
    },
  }),
  indicatorsContainer: (base) => ({
    ...base,
    position: "relative",
  }),
};

export default function InvoicesFilters({
  search,
  setSearch,
  year,
  setYear,
  setPage,
}) {
  const renderSearchFilter = () => {
    // const handleSearchChange = (value) => {
    //   setSearch(value);
    //   debounce(() => {
    //     const updatedSearchParams = updateSearchParams(searchParams, {
    //       search: value,
    //       page: '',
    //     });
    //     router.push(`${pathname}${updatedSearchParams}`);
    //   }, 500)();
    // };
    // return <SearchInput search={search} dict={dict} handleSearchChange={handleSearchChange} />;
  };

  const renderYearFilter = () => {
    const yearOptions = (() => {
      const startYear = 2026;
      const currentYear = moment().year();

      return Array.from({ length: currentYear - startYear + 1 }, (_, index) => {
        const year = currentYear - index;
        return { value: year, label: year };
      });
    })();

    const handleYearChange = (option) => {
      setYear(option.value);
      setPage(1);
    };

    return (
      <Select
        options={yearOptions}
        value={yearOptions.find((option) => option.value === year) ?? null}
        onChange={handleYearChange}
        styles={selectStyles}
        isClearable={false}
        // isSearchable={false}
        // components={{
        //   DropdownIndicator: (props) => getDropdownIndicator(props, !!value),
        // }}
      />
    );
  };

  return (
    <div className={styles.filters}>
      {renderYearFilter()}
      {/* <span className={styles.separator} /> */}
      {/* <div>{renderSearchFilter()}</div> */}
    </div>
  );
}
